import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { AuthenticationService, MediaWatcherService } from "../_services";
import { IUser } from "../_models";

interface IMenuItem {
    icon?: string;
    route?: string;
    title?: string;
    disabled: boolean;
}

@Component({
    selector: "app-menu",
    templateUrl: "menu.component.html",
    styleUrls: ["menu.component.css"]
})
export class MenuComponent implements OnInit, OnDestroy {
    currentUser: IUser;
    currentUserSubscription: Subscription;
    opened = true;
    over = "side";
    expandHeight = "42px";
    collapseHeight = "42px";
    displayMode = "flat";
    isMobile = false;
    mediaWatcherSubscription: Subscription;

    menuItems: IMenuItem[];

    constructor(private authenticationService: AuthenticationService, private mediaWatcherService: MediaWatcherService) {

    }

    ngOnInit() {
        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;

            if (this.currentUser) {
                this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
                    this.isMobile = isMobile;

                    if (this.isMobile) {
                        this.opened = false;
                        this.over = "over";
                    } else {
                        this.opened = true;
                        this.over = "side";
                    }
                });

                this.menuItems = [
                    {
                        icon: "home",
                        route: "/",
                        title: "Home",
                        disabled: false
                    }, {
                        icon: "transfer_within_a_station",
                        route: "/admissions",
                        title: "Admissions",
                        disabled: !this.currentUser.canApplyForAdmissions
                    },
                    {
                        icon: "location_city",
                        route: "/housing",
                        title: "Housing",
                        disabled: !this.currentUser.canApplyForHousing
                    },
                    {
                        icon: "psychology",
                        route: "/orientation",
                        title: "Orientation",
                        disabled: !this.currentUser.canViewOrientation
                    },
                    {
                        icon: "badge",
                        route: "/immigration",
                        title: "Immigration",
                        disabled: !this.currentUser.canViewImmigration
                    }
                    //{
                    //    icon: "monetization_on",
                    //    route: "/financialAid",
                    //    title: "Financial Aid",
                    //    disabled: true //!this.currentUser?.studentCode
                    //},
                    //{
                    //    icon: "school",
                    //    route: "/courses",
                    //    title: "Courses",
                    //    disabled: true
                    //}, {
                    //    icon: "today",
                    //    route: "/schedule",
                    //    title: "Schedule",
                    //    disabled: true
                    //}, {
                    //    icon: "shopping_cart",
                    //    route: "/bills",
                    //    title: "Bills",
                    //    disabled: true
                    //}
                ];
            }
        });
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    toggleSideNavParent(data: any) {
        this.opened = data.opened;
    }
}
